import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave, fnGetTableById } from "@shared/api/restApi"; // BackEnd API
import { getInitFormData, CalAm } from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import SnGrid from "@shared/components/GridV2/SnGrid"; // 공통 그리드
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface
import SnResizable from "@shared/components/SnResizable";
import SnResizeBar from "@shared/components/SnResizeBar";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import { showPopupModal } from "@widgets/CommonModal";
import ExcelUpload from "@widgets/commonpopup/ExcelUpload";
import SnTabHeader from "@shared/components/SnTabHeader";
import SnTab from "@shared/components/SnTab";
import { getNoSlip, getTablebySql } from "@shared/utils/CommonUtils";
import { global, globalMenu } from "@shared/libs/Global";
import SN_SAL_SAO_REG_001_TEX_POP_01 from "@menu/XTC/SN_SAL_SAO_REG_001_TEX/SN_SAL_SAO_REG_001_TEX_POP_01";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import { RowNode } from "ag-grid-community";
import { dateToString, formatYyyyMMdd } from "@shared/utils/DateUtils";
import SnButton from "@shared/components/SnButton";
import {
  ExcelUpload_S01_Validate,
  openS02,
  SlipNumberingFn,
  toNonEmptyString,
} from "@menu/XTC/SN_SAL_SAO_REG_001_TEX/excel-upload-tex";
const getNoSlipStrict: SlipNumberingFn = async (
  cd_module,
  no_line_tex,
  cd_prefix,
  date,
  cd_menu
) =>
  toNonEmptyString(
    await getNoSlip(cd_module, no_line_tex, cd_prefix, date, cd_menu),
    "전표번호가 비어 있습니다."
  );
interface Props {
  Menuprops: menuInfo;
}
interface ChangeSet {
  modifiedRowcount: number;
  insert: any[];
  update: any[];
  delete: any[];
}
const SN_SAL_SAO_REG_001_TEX = forwardRef(({ Menuprops }: Props, ref) => {
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
    grid3: React.createRef(),
    grid4: React.createRef(),
  });
  const sotypeRef = useRef<any[]>([]);
  const focusIndexRef = useRef<number | null>(null);
  const searchRef = useRef<any>(null);
  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const [selectedLineDocu, setSelectedLineDocu] = useState<number>(0);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const focusKeyRef = useRef<{
    no_so?: string;
  } | null>(null);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    grid4: [],
    sheet1: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
    grid4: [],
    sheet1: [],
  });
  const [gridFocus, setGridFocus] = useState(false);
  const [focusedRowData, setFocusedRowData] = useState<any>();
  const [isNewRow, setIsNewRow] = useState(false);
  const syncingFromHeaderRef = useRef(false);
  // 최초 조회에서 받은 롱포맷 피벗 데이터를 캐시한다.
  const pivotLongDataRef = useRef<any[]>([]);
  const { userInfo } = global();
  const [selectedTab, setSelectedTab] = useState("1");
  // 고정 슬롯(qt_wo1~qt_wo20)을 유지하고 헤더/노출만 변경한다.
  const sizeSlotColumns = useMemo(
    () => Array.from({ length: 20 }, (_, index) => `qt_wo${index + 1}`),
    []
  );

  const sheetref1 = useRef<any>(null); // excel download 용
  const [sheet1Columns, setSheet1Columns] = useState<any[]>([]); // excel 업로드용 컬럼
  const [sheetReady, setsheetReady] = useState(false); // 렌더링 완료 여부
  const addRowDefaultRef = useRef<any>(null);
  const noLineTexRef = useRef<number>(0);
  interface RowData {
    KeyField?: string; // 행의 고유 ID
    [key: string]: any;
  }

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({
          menuInfo: Menuprops,
        });
        setFormData(rtn.formData);
        setFormControlData(rtn.formControlData);
        const grid2 = rtn.grid.grid2;
        const popup_apply = [
          { target: "cd_var1", source: "cd_dummy01" },
          { target: "cd_var2", source: "cd_dummy02" },
        ];

        grid2.map((col: any) => {
          if (col.cd_column === "cd_item") col.popup_apply = popup_apply;
        });
        setColums({
          grid1: rtn.grid.grid1,
          grid2: grid2,
          grid3: rtn.grid.grid3,
          grid4: rtn.grid.grid4,
          sheet1: rtn.grid.sheet1,
        });
        setSheet1Columns(rtn.grid.sheet1);
        /*const payload = {
          id: "mas_sotype",
          params: { cd_firm: userInfo.cd_firm },
        };
        const data = await fnGetTableById(payload);
        if (Array.isArray(data) && data.length > 0) {
          sotypeRef.current = data;
        }*/
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
    onPrint,
    onExcelUpload,
    onExcelDownLoad,
  }));

  useEffect(() => {
    gridRefs.current["grid1"].current.selectAndFocusRow(0);
    setGridFocus(false);
  }, [gridFocus]);

  const onSearch = async () => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
    const selectedFormData = searchRef.current.getFormdata();
    if (selectedFormData.dt_from > selectedFormData.dt_to) {
      showDialog(
        "alter",
        " 조회기간의 종료일이 시작일보다빠릅니다.확인 후 다시 조회해주시기 바랍니다."
      );
      return;
    }
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
    }
    try {
      const params = {
        id: "sn_sal_sao_reg_001_tex_01",
        params: searchRef.current.getFormdata(),
      };
      setSelectedDocu("");
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0] || [],
        grid2: data[1] || [],
        grid3: [],
        grid4: data[3] || [],
        sheet1: data[4] || [],
      });
      // 포커스 변경 시 재조회하지 않도록 롱포맷 데이터를 메모리에 보관.
      pivotLongDataRef.current = data[2] || [];
      if (focusIndexRef.current === null) {
        if (data[0] && data[0].length > 0) {
          await new Promise((resolve) => setTimeout(resolve, 50));
          setGridFocus(true);
        }
      }
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      gridRefs.current["grid4"].current.resetUpdate();
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  //region onPrint
  const onPrint = async () => {
    const focusedRowNode = gridRefs.current["grid1"].current.focusedRowNode();

    if (!focusedRowNode || focusedRowNode.length === 0) {
      await showDialog("alert", "선택된 내용이 없습니다. 항목을 선택해 주세요");
      return;
    }

    const selectedData = focusedRowNode.data;

    return {
      no_style: selectedData?.no_style, // 스타일 번호
      cd_var1: selectedData?.cd_var1, // 핏 모디파이어
      cd_var2: selectedData?.cd_var2, // 컬러 코드
      cd_var3: selectedData?.cd_var3, // 사이즈
    };
  };

  //#region On Insert
  const onInsert = async () => {
    try {
      const salsohChanges =
        gridRefs.current["grid1"].current.getChange().insert;
      const ctrlValue = searchRef.current.getFormdata();

      if (salsohChanges.length > 0) return false;
      const sqlQuery = {
        sql: `select a.*,b.dc_ref
          from(
            select cd_so,fg_trns,tp_sales,yn_trade,yn_app,cd_firm,
            case when fg_trns = '1' then '11'
            when fg_trns = '2' or fg_trns = '3' then '14'
            else '15' end as fg_vat
            from mas_sotype 
            where cd_firm = :cd_firm and yn_use = 'Y' and cd_so = '5100'
            ) a left outer join mas_codel b on a.cd_firm = b.cd_firm
            where b.cd_firm = :cd_firm
            and b.cd_clas = 'SYS013'
            and b.cd_flag = a.fg_vat ;`,
        cd_firm: userInfo.cd_firm,
      };
      const rows = await getTablebySql(sqlQuery);
      const findExistingData = rows?.[0];

      const newRow = {
        cd_firm: userInfo?.cd_firm,
        cd_biz: userInfo?.cd_biz,
        cd_dept: userInfo?.cd_dept,
        cd_emp: userInfo?.cd_emp,
        nm_emp: userInfo?.nm_emp,
        cd_gp: userInfo?.cd_gp,
        cd_so: findExistingData.cd_so,
        fg_trns: findExistingData.fg_trns,
        vat_late: findExistingData.dc_ref,
        dt_dlv: todayform,
        fg_money: "1",
        tp_um: "001",
        cd_exch: "000",
        rt_exch: 1,
        fg_vat:
          findExistingData.fg_trns === "1"
            ? "11"
            : findExistingData.fg_trns === "2" ||
                findExistingData.fg_trns === "3"
              ? "14"
              : "15",
        tp_sales: findExistingData.tp_sales,
        yn_trade: findExistingData.yn_trade,
        st_so: findExistingData.yn_app === "Y" ? "R" : "F",
        no_po: "",
        dt_so: todayform,
        cd_cust: ctrlValue.cd_cust,
        nm_cust: ctrlValue.nm_cust,
        am: 0,
        am_k: 0,
        am_vat: 0,
        am_supply: 0,
        _isNew: true,
      };
      gridRefs.current["grid1"].current?.addRow(newRow);
    } catch (error: any) {}
  };

  //#region On Delete
  const onDelete = async () => {
    const gridApiH = gridRefs.current["grid1"].current;
    const rowCount = gridApiH.getDisplayedRowCount();
    if (rowCount === 0) {
      return;
    }

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");

    if (!confirm) {
      return;
    }

    gridRefs.current["grid2"].current?.deleteAllRows();
    gridRefs.current["grid1"].current?.deleteSelectedRows();
    const realDeletedRows =
      gridRefs.current["grid1"].current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      return;
    }
    await onSave();
  };

  const onExcelDownLoad = async () => {
    try {
      const displayedCols = sheetref1.current?.getAllDisplayedColumns() || [];
      const columnKeys = displayedCols.map((c: any) => c.getColId());

      sheetref1.current?.exportDataAsExcel({
        columnKeys,
        skipPinnedBottom: true,
        fileName: `${globalMenu.getState().activeMenuInfo.nm_menu}.xlsx`,
        sheetName: "Sheet1",
      });
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onExcelUpload = async () => {
    try {
      const component = (
        <ExcelUpload_S01_Validate
          Menuprops={Menuprops} // 메뉴 정보 전달
          grouping={[
            "no_so",
            "dt_so",
            "cd_cust",
            "cd_so",
            "no_po",
            "cd_exch",
            "rt_exch",
            "tp_um",
            "cd_gp",
            "cd_emp",
            "cd_cust_dlv",
          ]} // 그룹핑할 필드 목록 전달
          pkFields={["no_so", "no_line_tex"]} // PK 필드 목록 전달
          onNext={async ({
            validRows,
            headerColumns,
            detailColumns,
            grouping,
          }: {
            validRows: any[];
            headerColumns: any[];
            detailColumns: any[];
            grouping: string[];
          }) => {
            if (!Menuprops.cd_menu) {
              showDialog?.(
                "error",
                "메뉴 코드(Menuprops.cd_menu)가 비어 있습니다."
              );
              return;
            }

            await openS02({
              validRows,
              headerColumns,
              detailColumns,
              grouping,
              controller: "SN_SAL_SAO_REG_001_TEX_SAVE_01",
              numbering: {
                fn: getNoSlipStrict,
                options: {
                  cd_module: "SAL",
                  no_line_tex: 1, //  sys_notescount.no_line 값으로 교체
                  cd_prefix: "SOR",
                  dateField: "dt_so", // ← 헤더 날짜 '컬럼명'
                  cd_menu: Menuprops.cd_menu,
                },
              },
              upsert: { mode: "create-or-append", allowDelete: false },
              tables: {
                header: "sal_soh",
                detail: "sal_sol_tex",
                blind: "sal_sol",
              },

              fieldMap: {
                headerNoField: "no_so",
                detailNoField: "no_so",
                lineNoField: "no_line_tex",
              },
            });
          }}
        />
      );

      const result = await showPopupModal({
        title: "수주 엑셀 업로드",
        children: component,
        width: "80%",
        height: "90VH",
        okayBtnText: "다음",
        checkData: false,
      });

      if (result) {
        onSearch();
        console.log("엑셀 업로드 완료:", result);
      } else {
        console.log("엑셀 업로드 취소됨");
      }
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  //#region On AddRow
  const onAddRow = async () => {
    try {
      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return;
      }
      if (
        !gridRefs.current["grid1"] ||
        gridRefs.current["grid1"].current.getSelectedRows().length === 0
      ) {
        alert("선택된 행이 없습니다.");
        return false;
      }
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      const sqlQuery = {
        sql: `select a.*, b.dc_ref
                    from(
                        select fg_trns,tp_sales,yn_trade,yn_app,cd_firm,
                               case when fg_trns = '1' then '11'
                                    when fg_trns = '2' or fg_trns = '3' then '14'
                                    else '15' end as fg_vat
                        from mas_sotype where cd_firm = :cd_firm and cd_so = :cd_so
                    ) a left outer join mas_codel b on a.cd_firm = b.cd_firm
                    where b.cd_firm = :cd_firm
                      and b.cd_clas = 'SYS013'
                      and b.cd_flag = a.fg_vat`,
        cd_firm: userInfo.cd_firm,
        cd_so: focusedNodeH.data.cd_so,
      };
      const rows = await getTablebySql(sqlQuery);
      addRowDefaultRef.current = {
        cd_so: rows[0].cd_so,
        vat_late: rows[0].dc_ref,
        fg_trns: rows[0].fg_trns,
        dt_dlv: focusedNodeH.data.dt_dlv,
        fg_vat:
          rows[0].fg_trns === "1"
            ? "11"
            : rows[0].fg_trns === "2" || rows[0].fg_trns === "3"
              ? "14"
              : "15",
        tp_sales: rows[0].tp_sales,
        yn_trade: rows[0].yn_trade,
        st_so: rows[0].yn_app === "Y" ? "R" : "F",
      };
      noLineTexRef.current =
        gridRefs.current["grid2"].current.getMaxValue("no_line_tex") ?? 0;
      gridRefs.current["grid2"].current?.addRow(addRowDefaultRef);
    } catch (error: any) {}
  };

  //#region On DeleteRow
  const onDeleteRow = () => {
    const gridApil = gridRefs.current["grid2"].current;
    const rowCount = gridApil.getDisplayedRowCount();
    if (rowCount === 0) {
      return;
    }

    gridRefs.current["grid2"].current?.deleteSelectedRows();
  };

  //region onRowDoubleClick
  const onRowDoubleClick = async (event: any) => {
    const rowData = event.data;
    const selectedFormData = searchRef.current.getFormdata();
    const selectedData = { cd_biz: selectedFormData.cd_biz };

    const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    const grid2Changes = gridRefs.current["grid1"].current.getChange().insert;

    if (grid2Changes.length === 0 || focusedNodeH?.colId !== "no_style") {
      return;
    }

    const component = (
      <SN_SAL_SAO_REG_001_TEX_POP_01 selectedData={selectedData} />
    );
    const result = await showPopupModal({
      title: "LC조회",
      children: component,
    });
    if (!result || result === "close") return;

    let index = 0;
    const lineResult = result[0];

    for (const item of lineResult) {
      const rowCount = gridRefs.current["grid1"].current.getDisplayedRowCount();
      const lastRowIndex = rowCount - 1;
      const lastRowNode = gridRefs.current["grid1"].current.getRowNodeAtIndex(
        focusedNodeH.rowIndex
      );
      gridRefs.current["grid1"].current.clearFocus();
      if (index === 0 && lastRowNode) {
        //updateRowValues1(lastRowNode, item);
      } else {
        onAddRow();
        const newLastRowNode = gridRefs.current[
          "grid1"
        ].current.getRowNodeAtIndex(lastRowIndex + 1);
        if (newLastRowNode) {
          //updateRowValues1(newLastRowNode, item);
        }
      }
      index++;
    }
  };

  const testNode = (row: any) => {
    let result: any = undefined;
    gridRefs.current["grid4"].current?.forEachFilteredNode((node: any) => {
      if (
        node.data?.no_so === row.no_so &&
        node.data?.cd_item === row.cd_item &&
        node.data?.cd_dummy01 === row.cd_dummy01
      )
        result = node.data;
    });
    return result;
  };

  //#region  OnSave
  const onSave = async () => {
    let salSohChanges;
    //let salSolChanges: any;
    let salSolTexChanges: any;

    try {
      // Stop editing
      gridRefs.current["grid1"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();

      // Validate required fields (Header)
      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return;

      // Validate required fields (Line)
      const requiredValuesCheckL =
        gridRefs.current["grid2"].current.requiredValuesCheck();
      if (!requiredValuesCheckL) return;

      // Get changes
      salSohChanges = gridRefs.current["grid1"].current.getChange();
      salSolTexChanges = gridRefs.current["grid2"].current.getChange();
      const headerInserts = salSohChanges.insert ?? [];
      const lineInserts = salSolTexChanges.insert ?? [];
      const displayedRowCount =
        gridRefs.current["grid2"].current.getDisplayedRowCount();

      const lineDeleteCount = salSolTexChanges.delete?.length ?? 0;
      const headerDeleteCount = salSohChanges.delete?.length ?? 0;

      // 🔹 케이스 1: 하단 row 0 + header delete 있음 → 전체 삭제 → OK
      const isFullDelete = displayedRowCount === 0 && headerDeleteCount > 0;

      // 🔹 케이스 2: 하단 row 0 + 하단만 delete → ❌
      const isLineOnlyDelete =
        displayedRowCount === 0 &&
        lineDeleteCount > 0 &&
        headerDeleteCount === 0;

      // 🔹 케이스 3: 아무 변경도 없음
      const hasAnyChange =
        (salSohChanges.modifiedRowcount ?? 0) > 0 ||
        (salSolTexChanges.modifiedRowcount ?? 0) > 0;

      // ❌ 하단만 전부 삭제한 경우
      if (isLineOnlyDelete) {
        showDialog(
          "error",
          "상세내역만 전체 삭제할 수 없습니다.\n상단도 함께 삭제하세요."
        );
        return;
      }

      // ❌ 상세가 없고 전체 삭제도 아닌 경우
      if (displayedRowCount === 0 && !isFullDelete) {
        showDialog("error", "상세내역을 입력하세요.");
        return;
      }

      if (
        salSohChanges.modifiedRowcount === 0 &&
        salSolTexChanges.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      const salSolChanges: ChangeSet = {
        modifiedRowcount: 0,
        insert: [],
        update: [],
        delete: [],
      };

      const numericFields = [
        "qt",
        "am",
        "am_k",
        "am_vat",
        "am_supply",
      ] as const;
      const toNum = (v: any) =>
        typeof v === "number"
          ? v
          : Number(String(v ?? "").replace(/,/g, "")) || 0;

      const addSum = (dst: any, src: any) => {
        ["cd_firm", "no_so", "cd_item", "cd_dummy01", "no_line"].forEach(
          (f) => {
            dst[f] = src[f];
          }
        );
        numericFields.forEach((f) => {
          dst[f] = toNum(dst[f]) + toNum(src[f]);
        });
        return dst;
      };
      const updateDataCheck = (dst: any) => {
        numericFields.forEach((f) => {
          dst[f] = toNum(dst[f]);
        });
        return dst;
      };

      const keyOf = (r: any) =>
        `${r.no_so ?? ""}||${r.cd_item ?? ""}||${r.cd_dummy01 ?? ""}`;
      const lineMapKeyOf = (r: any) =>
        `${r.cd_item ?? ""}||${r.cd_dummy01 ?? ""}`;
      // 임시 집계 버킷
      const pendingInsert = new Map<string, any>();
      const pendingUpdate = new Map<string, any>();
      const deletedSolSet = new Set<string>();
      (["insert", "update", "delete"] as const).forEach((key) => {
        (salSolTexChanges[key] || []).forEach((row: any) => {
          switch (key) {
            case "insert":
              const node = testNode(row);
              if (!node) {
                // ★ N에 없으므로 insert 집계: 같은 키면 1건으로 묶고 숫자 합산
                const k = keyOf(row);
                if (pendingInsert.has(k)) {
                  addSum(pendingInsert.get(k), row);
                } else {
                  pendingInsert.set(k, { ...row }); // 최초 한 건
                }
              } else {
                const k = keyOf(row);
                if (pendingUpdate.has(k)) {
                  addSum(pendingUpdate.get(k), row);
                } else {
                  // 기존 node.data를 베이스로 합산
                  const base = { ...node };
                  pendingUpdate.set(k, addSum(base, row));
                }
              }
              break;
            case "update":
              const k = keyOf(row);
              if (pendingUpdate.has(k)) {
                addSum(pendingUpdate.get(k), row);
              } else {
                const node = testNode(row);
                const base = node ? { ...node } : { ...row };
                let sumQt = 0,
                  sumUm = 0,
                  sumAm = 0,
                  sumAm_k = 0,
                  sumAm_vat = 0,
                  sumAm_supply = 0;
                gridRefs.current["grid2"].current?.forEachFilteredNode(
                  (node: any) => {
                    if (
                      node.data?.no_so === row.no_so &&
                      node.data?.cd_item === row.cd_item &&
                      node.data?.cd_dummy01 === row.cd_dummy01
                    ) {
                      sumQt += node.data.qt;
                      sumUm += node.data.um;
                      sumAm += node.data.am;
                      sumAm_k += node.data.am_k;
                      sumAm_vat += node.data.am_vat;
                      sumAm_supply += node.data.am_supply;
                    }
                  }
                );
                base.qt = sumQt;
                base.um = sumUm;
                base.am = sumAm;
                base.am_k = sumAm_k;
                base.am_vat = sumAm_vat;
                base.am_supply = sumAm_supply;
                pendingUpdate.set(k, updateDataCheck(base));
              }
              break;
            case "delete":
              const ke = keyOf(row);
              const noded = testNode(row);
              const base = noded
                ? { ...noded }
                : {
                    ...row,
                    no_line: row.no_line_so, // ✅ fallback
                  };
              const solKey = `${row.no_so}_${row.cd_item}_${row.cd_dummy01}_${base.no_line}`;

              if (deletedSolSet.has(solKey)) {
                // 👉 이미 처리한 sol이면 스킵
                return; // 또는 continue 역할
              }

              deletedSolSet.add(solKey);
              // 🔹 같은 cd_item에 남은 tex 행 합산
              let sumQt = 0,
                sumUm = 0,
                sumAm = 0,
                sumAm_k = 0,
                sumAm_vat = 0,
                sumAm_supply = 0;

              gridRefs.current["grid2"].current?.forEachFilteredNode(
                (noded: any) => {
                  if (
                    noded.data?.no_so === row.no_so &&
                    noded.data?.cd_item === row.cd_item &&
                    noded.data?.cd_dummy01 === row.cd_dummy01
                  ) {
                    sumQt += noded.data.qt;
                    sumUm += noded.data.um;
                    sumAm += noded.data.am;
                    sumAm_k += noded.data.am_k;
                    sumAm_vat += noded.data.am_vat;
                    sumAm_supply += noded.data.am_supply;
                  }
                }
              );

              base.qt = sumQt;
              base.um = sumUm;
              base.am = sumAm;
              base.am_k = sumAm_k;
              base.am_vat = sumAm_vat;
              base.am_supply = sumAm_supply;

              if (base.qt > 0) {
                // 1건만 삭제 → 수량 줄어듦 → update 처리
                pendingUpdate.set(ke, updateDataCheck(base));
              } else {
                // 전부 삭제된 경우 → delete 처리
                // 🔹 단, 같은 cd_item이 insert 목록에 다시 추가된 경우엔
                //     delete 먼저 실행되고 insert가 뒤따르도록 분리
                if (
                  salSolChanges.insert.some(
                    (ins: any) =>
                      ins.no_so === row.no_so &&
                      ins.cd_item === row.cd_item &&
                      ins.cd_dummy01 === row.cd_dummy01
                  )
                ) {
                  // insert도 있으니 delete 먼저 수행
                  salSolChanges.delete.push({
                    ...row,
                    no_line: base.no_line, // ✅ 핵심
                  });
                } else {
                  // 순수 delete
                  salSolChanges.delete.push({
                    ...row,
                    no_line: base.no_line, // ✅ 핵심
                  });
                }
              }
              break;
          }
        });
      }); // foreach last

      salSolChanges.insert = Array.from(pendingInsert.values());
      salSolChanges.update = Array.from(pendingUpdate.values());
      salSolChanges.modifiedRowcount =
        salSolChanges.insert.length +
        salSolChanges.update.length +
        salSolChanges.delete.length;

      let maxLine = 0;
      const itemLineMap: Record<string, number> = {};
      const findExistingLine = (row: any) => {
        let result: number | undefined;
        gridRefs.current["grid4"].current?.forEachFilteredNode((node: any) => {
          const val = Number(node.data?.no_line || 0);
          if (val > maxLine) maxLine = val;

          if (
            result == null &&
            node.data?.no_so === row.no_so &&
            node.data?.cd_item === row.cd_item &&
            node.data?.cd_dummy01 === row.cd_dummy01
          ) {
            result = val;
          }
        });
        return result;
      };

      const assignLine = (row: any, isInsert: boolean) => {
        const mapKey = lineMapKeyOf(row);
        const mappedLine = itemLineMap[mapKey];
        const existingLine = mappedLine ?? findExistingLine(row);

        if (existingLine != null && existingLine > 0) {
          row.no_line = existingLine;
          itemLineMap[mapKey] = existingLine;
          return;
        }

        if (!isInsert && Number(row.no_line_so || 0) > 0) {
          row.no_line = Number(row.no_line_so);
          itemLineMap[mapKey] = row.no_line;
          return;
        }

        maxLine += 1;
        row.no_line = maxLine;
        itemLineMap[mapKey] = row.no_line;
      };

      salSolChanges.update
        .sort((a: any, b: any) =>
          String(a.cd_item).localeCompare(String(b.cd_item))
        )
        .forEach((row: any) => assignLine(row, false));
      salSolChanges.insert
        .sort((a: any, b: any) =>
          String(a.cd_item).localeCompare(String(b.cd_item))
        )
        .forEach((row: any) => assignLine(row, true));

      // 2️⃣ salSolTexChanges에 no_line_so 부여
      for (const row of [
        ...salSolTexChanges.insert,
        ...salSolTexChanges.update,
      ]) {
        const lineSo = itemLineMap[lineMapKeyOf(row)] ?? findExistingLine(row);
        if (lineSo != null) {
          // cd_item이 같은 경우, 동일한 no_line_so 적용
          row.no_line_so = lineSo;
        } else {
          showDialog("error", "수주 상세 라인 매핑에 실패했습니다.");
          return;
        }
      }

      for (let row of headerInserts) {
        if (!row.no_so) {
          const cd_module: any = Menuprops.cd_module;
          const cd_menu: any = Menuprops.cd_menu;

          try {
            const no_slip = await getNoSlip(
              "SAL",
              1, // no_line flag
              "SOR", // cd_prefix
              row.dt_so, // date
              cd_menu // cd_user
            );
            if (no_slip) {
              row.no_so = no_slip;

              // Update cell in grid
              const gridApiH = gridRefs.current["grid1"].current;
              const focusedCell = gridApiH.focusedRowNode();
              if (focusedCell) {
                focusedCell.setDataValue("qt_work", no_slip);
              }
              for (let row of lineInserts) {
                if (!row.no_so) row.no_so = no_slip;
                if (!row.KeyField) {
                  row.KeyField = crypto.randomUUID();
                }
              }
              gridRefs.current["grid2"].current.applyFilters({
                no_so: no_slip,
              });
              gridRefs.current["grid4"].current.applyFilters({
                no_so: no_slip,
              });

              salSolChanges.insert?.forEach((r) => (r.no_so = no_slip));
              salSolChanges.update?.forEach((r) => (r.no_so = no_slip));
            }
          } catch (error) {}
        }
        if (row.no_po !== "" && row.no_po !== undefined) {
          const payload = {
            id: "duplication_no_po",
            params: { cd_firm: userInfo.cd_firm, no_po: row.no_po },
          };
          const noPo_duplication = await fnGetTableById(payload);
          if (noPo_duplication.length > 0) {
            const confirm = await showDialog(
              "confirm",
              "수주일 " +
                formatYyyyMMdd(noPo_duplication[0].dt_so) +
                " 기준,\n중복된 PO번호가 존재합니다.\n저장하시겠습니까?"
            );
            if (!confirm) return;
          }
        }
      }

      const SaveData = {
        sal_soh: salSohChanges,
        sal_sol_tex: salSolTexChanges,
        sal_sol: salSolChanges,
      };
      // Save to backend
      await fnSave("SN_SAL_SAO_REG_001_TEX_SAVE_01", SaveData);

      // Reset buffer
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid4"].current.resetUpdate();
      const selectRow = gridRefs.current["grid1"].current.focusedRowNode();
      if (selectRow) {
        focusKeyRef.current = {
          no_so: selectRow.data.no_so,
        };
      }
      await onSearch();
    } catch (error: any) {
      // Reset update buffer
      gridRefs.current["grid1"].current.resetUpdate(true);
      gridRefs.current["grid2"].current.resetUpdate(true);
      gridRefs.current["grid4"].current.resetUpdate(true);
    }
  };

  //region onGrid1BtnsClick
  const onGrid1BtnsClick = async (id: string) => {
    if (id == "aButton_app") {
      try {
        const newRow = {};
        gridRefs.current["grid2"].current?.addRow(newRow);
        const component = (
          <ExcelUpload
            Menuprops={Menuprops} // 메뉴 정보 전달
            PkFields={["cd_item"]} // PK 필드 목록 전달
            tableName="mas_item" // 저장할 테이블 이름
            controllerName="SN_SAL_SAO_REG_001_TEX_SAVE_01" // 저장할 컨트롤러 이름
            // columnMap= {{
            // "style number": "no_style",
            // "fit modifier": "cd_var1",
            // "color code": "cd_var2",
            // "size": "cd_var3",
            // "ordered qty": "qt",
            // }}
          />
        );

        const result = await showPopupModal({
          title: "엑셀 업로드",
          children: component,
          width: "80%",
          height: "90VH",
          okayBtnText: "저장",
        });

        if (result) {
          console.log("엑셀 업로드 완료:", result);
        } else {
          console.log("엑셀 업로드 취소됨");
        }
      } catch (error: any) {
        showDialog("error", error.message);
      }
    }
  };

  //region onGrid2BtnsClick
  const onGrid2BtnsClick = async (id: string) => {
    if (id == "button_app") {
      const mtlQtiohChanges =
        gridRefs.current["grid1"].current.getChange().insert;
      if (mtlQtiohChanges.length === 0) {
        await showDialog("alter", "신규행을 추가하시기 바랍니다.");
        return;
      }
    }
  };

  const onGridBtnsClick = async (id: string) => {
    if (id === "stSoEnd") {
      const focusedRowNode = gridRefs.current["grid1"].current.focusedRowNode();
      if (!focusedRowNode || focusedRowNode.length === 0) {
        await showDialog(
          "alert",
          "선택된 내용이 없습니다. 항목을 선택해 주세요"
        );
        return;
      }
      const update_sal_soh_st_so = {
        id: "update_sal_soh_st_so",
        params: {
          cd_firm: userInfo.cd_firm,
          st_so: "X",
          no_so: focusedRowNode.data.no_so,
          cd_user_amd: userInfo.cd_user,
        },
      };
      const update_sal_sol_st_so = {
        id: "update_sal_sol_st_so",
        params: {
          cd_firm: userInfo.cd_firm,
          st_so: "X",
          no_so: focusedRowNode.data.no_so,
          cd_user_amd: userInfo.cd_user,
        },
      };
      await fnGetTableById(update_sal_soh_st_so);
      await fnGetTableById(update_sal_sol_st_so);
      focusIndexRef.current = focusedRowNode.rowIndex;
      await onSearch();
    } else if (id === "stSoCancel") {
      const focusedRowNode = gridRefs.current["grid1"].current.focusedRowNode();
      if (!focusedRowNode || focusedRowNode.length === 0) {
        await showDialog(
          "alert",
          "선택된 내용이 없습니다. 항목을 선택해 주세요"
        );
        return;
      }
      const update_sal_soh_st_so = {
        id: "update_sal_soh_st_so",
        params: {
          cd_firm: userInfo.cd_firm,
          st_so: "R",
          no_so: focusedRowNode.data.no_so,
          cd_user_amd: userInfo.cd_user,
        },
      };
      const update_sal_sol_st_so = {
        id: "update_sal_sol_st_so",
        params: {
          cd_firm: userInfo.cd_firm,
          st_so: "R",
          no_so: focusedRowNode.data.no_so,
          cd_user_amd: userInfo.cd_user,
        },
      };
      await fnGetTableById(update_sal_soh_st_so);
      await fnGetTableById(update_sal_sol_st_so);
      focusIndexRef.current = focusedRowNode.rowIndex;
      await onSearch();
    } else if (id === "stSoC") {
      const focusedRowNode = gridRefs.current["grid1"].current.focusedRowNode();
      if (!focusedRowNode || focusedRowNode.length === 0) {
        await showDialog(
          "alert",
          "선택된 내용이 없습니다. 항목을 선택해 주세요"
        );
        return;
      }
      const update_sal_soh_st_so = {
        id: "update_sal_soh_st_so",
        params: {
          cd_firm: userInfo.cd_firm,
          st_so: "C",
          no_so: focusedRowNode.data.no_so,
          cd_user_amd: userInfo.cd_user,
        },
      };
      const update_sal_sol_st_so = {
        id: "update_sal_sol_st_so",
        params: {
          cd_firm: userInfo.cd_firm,
          st_so: "C",
          no_so: focusedRowNode.data.no_so,
          cd_user_amd: userInfo.cd_user,
        },
      };
      await fnGetTableById(update_sal_soh_st_so);
      await fnGetTableById(update_sal_sol_st_so);
      focusIndexRef.current = focusedRowNode.rowIndex;
      await onSearch();
    }
  };
  const onGridBtnsClick1 = async (id: string) => {
    if (id === "addRow") {
      onAddRow();
    }

    if (id === "deleteRow") {
      onDeleteRow();
    }
  };

  const onGridBtnsClick2 = async (id: string) => {
    if (id === "addRow") {
      onAddRow();
    }

    if (id === "deleteRow") {
      onDeleteRow();
    }
  };

  const onCellValueChangedH = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const gridApiH = gridRefs.current["grid1"].current;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    if (gridApiH) {
      const selectedDataH = gridApiH.getSelectedRows();
      if (selectedDataH.length > 0) {
        selectedDataH.forEach((row: any) => {
          if (row.cd_cust !== row._previousCdCust) {
            row.cd_cust_dlv = row.cd_cust; // cd_cust_dlv에 값을 넣음
          }
        });
      }
    }
    if (colId === "rt_exch") {
      syncingFromHeaderRef.current = true;
      let totalAm = 0,
        totalUm = 0,
        totalAm_k = 0,
        totalAm_vat = 0,
        totalAm_supply = 0;
      gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) => {
        const rt_exch = Number(rowData.rt_exch ?? 1);
        const qt = Number(node.data.qt ?? 0);
        const um = Number(node.data.um ?? 0);

        const newAm = qt * um;
        const newAmK = newAm * rt_exch;
        const newAmVat = Math.floor((newAmK * rowData.vat_late) / 100);
        const newAmSupply = newAmK + newAmVat;
        const newUmK = um * rt_exch;
        node.setDataValue("am", newAm);
        node.setDataValue("am_k", newAmK);
        node.setDataValue("am_vat", newAmVat);
        node.setDataValue("am_supply", newAmSupply);
        node.setDataValue("um_k", newUmK);
        node.setDataValue(
          "um_supply",
          newUmK + Math.floor((newUmK * rowData.vat_late) / 100)
        );
        totalAm += newAm;
        totalUm += um;
        totalAm_k += newAmK;
        totalAm_vat += newAmVat;
        totalAm_supply += newAmSupply;
      });
      rowNode.setDataValue("am", totalAm);
      rowNode.setDataValue("um", totalUm);
      rowNode.setDataValue("am_k", totalAm_k);
      rowNode.setDataValue("am_vat", totalAm_vat);
      rowNode.setDataValue("am_supply", totalAm_supply);
      setTimeout(() => {
        syncingFromHeaderRef.current = false;
      }, 0);
    } else if (colId === "no_so") {
      // 필터링
      gridRefs.current["grid2"].current.applyFilters({
        no_so: rowData.no_so,
      });
      gridRefs.current["grid4"].current.applyFilters({
        no_so: rowData.no_so,
      });
    } else if (colId === "cd_cust") {
      rowNode.setDataValue("cd_cust_dlv", rowData.cd_cust);
      rowNode.setDataValue("nm_cust_dlv", rowData.nm_cust_sort);
    } else if (colId === "cd_so") {
      syncingFromHeaderRef.current = true;
      const sqlQuery = {
        sql: `select a.*, b.dc_ref
                    from(
                        select fg_trns,tp_sales,yn_trade,yn_app,cd_firm,
                               case when fg_trns = '1' then '11'
                                    when fg_trns = '2' or fg_trns = '3' then '14'
                                    else '15' end as fg_vat
                        from mas_sotype where cd_firm = :cd_firm and cd_so = :cd_so
                    ) a left outer join mas_codel b on a.cd_firm = b.cd_firm
                    where b.cd_firm = :cd_firm
                      and b.cd_clas = 'SYS013'
                      and b.cd_flag = a.fg_vat`,
        cd_firm: userInfo.cd_firm,
        cd_so: rowData.cd_so,
      };

      const rows = await getTablebySql(sqlQuery);
      rowNode.setDataValue("fg_trns", rows[0].fg_trns);
      let fg_vat = "";
      if (rows[0].fg_trns === "1") {
        fg_vat = "11";
      } else if (rows[0].fg_trns === "2" || rows[0].fg_trns === "3") {
        fg_vat = "14";
      } else {
        fg_vat = "15";
      }
      rowNode.setDataValue("fg_vat", fg_vat);
      rowNode.setDataValue("vat_late", rows[0].dc_ref);
      let totalAm = 0,
        totalUm = 0,
        totalAm_k = 0,
        totalAm_vat = 0,
        totalAm_supply = 0;
      gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) => {
        const rt_exch = Number(rowData.rt_exch ?? 1);
        const qt = Number(node.data.qt ?? 0);
        const um = Number(node.data.um ?? 0);

        const newAm = qt * um;
        const newAmK = newAm * rt_exch;
        const newAmVat = Math.floor((newAmK * rowData.vat_late) / 100);
        const newAmSupply = newAmK + newAmVat;
        const newUmK = um * rt_exch;
        totalAm += newAm;
        totalUm += um;
        totalAm_k += newAmK;
        totalAm_vat += newAmVat;
        totalAm_supply += newAmSupply;
        node.setDataValue("am", newAm);
        node.setDataValue("am_k", newAmK);
        node.setDataValue("am_vat", newAmVat);
        node.setDataValue("am_supply", newAmSupply);
        node.setDataValue("um_k", newUmK);
        node.setDataValue(
          "um_supply",
          newUmK + Math.floor((newUmK * rowData.vat_late) / 100)
        );
        node.setDataValue("fg_vat", fg_vat);
        node.setDataValue("vat_late", rows[0].dc_ref);
      });
      setTimeout(() => {
        syncingFromHeaderRef.current = false;
      }, 0);
      rowNode.setDataValue("am", totalAm);
      rowNode.setDataValue("um", totalUm);
      rowNode.setDataValue("am_k", totalAm_k);
      rowNode.setDataValue("am_vat", totalAm_vat);
      rowNode.setDataValue("am_supply", totalAm_supply);
      rowNode.setDataValue("tp_sales", rows[0].tp_sales);
      rowNode.setDataValue("yn_trade", rows[0].yn_trade);
      rowNode.setDataValue("st_so", rows[0].yn_app === "Y" ? "R" : "F");
    } else if (colId === "dt_dlv") {
      gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) => {
        node.setDataValue("dt_dlv", rowData.dt_dlv, "noEvent");
      });
    } else if (colId === "no_po") {
      const noPo = String(rowData.no_po ?? "").trim();
      if (noPo.length <= 2 || !/^\d{3}$/.test(noPo.substring(0, 3))) {
        await showDialog("alert", "PO 형식이 맞지 않습니다.");
        rowNode.setDataValue("no_po", "", "noEvent");
        return;
      }
    }
  };

  const onCellValueChangedL = async (event: CellValueChangedEvent) => {
    if (!event) return;

    // 수정된 컬럼 ID 및 정보
    const colId = event.colId; // 수정된 컬럼의 ID
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    if (syncingFromHeaderRef.current) {
      return;
    }
    if (colId === "cd_item") {
      const cd_item = rowData.cd_item;
      if (!cd_item) return;
      const params = {
        id: "sn_sal_sao_reg_001_tex_02",
        params: {
          cd_firm: userInfo.cd_firm,
          cd_item: cd_item,
        },
      };

      const data: any = await fnGetDataSet(params);
      if (data[0][0].no_style !== null) {
        const styleInfo = data[0][0];
        rowData.no_style = styleInfo.no_style;
        rowData.nm_style = styleInfo.nm_style;

        event.rowNode.setDataValue("no_style", styleInfo.no_style, "noEvent");
        event.rowNode.setDataValue("nm_style", styleInfo.nm_style, "noEvent");
        event.rowNode.setDataValue("cd_var1", styleInfo.cd_dummy01, "noEvent");
        event.rowNode.setDataValue("cd_var2", styleInfo.cd_dummy02, "noEvent");
        event.rowNode.setDataValue("cd_var3", styleInfo.cd_dummy05, "noEvent");
        gridRefs.current["grid2"].current.setFocusedCell(
          rowNode.rowIndex,
          "qt"
        );
      }
    }

    // const focusedCellH = gridRefs.current["grid1"].current.focusedRowNode();
    // 수정된 컬럼 ID 및 정보
    if (colId === "qt" || colId === "um") {
      const focusedCellH = gridRefs.current["grid1"].current.focusedRowNode();
      // 수정된 컬럼 ID 및 정보
      calculateAmounts(focusedCellH, rowData, colId, rowNode);
    }
    //calculateAmounts(focusedCellH, rowData, colId);
    // gridApiRefL에서 footerData 가져오기
  };
  const calculateAmounts = (
    rowHeader: any,
    row: any,
    fieldName: string,
    rowNode: any
  ) => {
    if (!rowHeader?.data || !row || !fieldName) {
      return;
    }
    const rt_exch = Number(rowHeader.data.rt_exch ?? 1);
    const qt = Number(row.qt ?? 0);
    const um = Number(row.um ?? 0);
    const am = Number(row.am ?? 0);
    const am_k = Number(row.am_k ?? 0);
    const vat_late = Number(row.vat_late ?? 0);
    switch (fieldName) {
      case "qt":
      case "um":
      case "rt_exch": {
        const newAm = qt * um;
        const newAmK = newAm * rt_exch;
        const newAmVat = Math.floor((newAmK * vat_late) / 100);
        const newAmSupply = newAmK + newAmVat;
        rowNode.setDataValue("am", newAm, "noEvent");
        rowNode.setDataValue("am_k", newAmK, "noEvent");
        rowNode.setDataValue("am_vat", newAmVat, "noEvent");
        rowNode.setDataValue("am_supply", newAmSupply, "noEvent");
        rowNode.setDataValue("um_k", um * rt_exch, "noEvent");
        rowNode.setDataValue(
          "um_supply",
          Math.floor((row.um_k * vat_late) / 100) + row.um_k,
          "noEvent"
        );
        break;
      }

      case "am": {
        const newAmK = am * rt_exch;
        rowNode.setDataValue("am_k", newAmK, "noEvent");
        rowNode.setDataValue(
          "am_vat",
          Math.floor((newAmK * vat_late) / 100),
          "noEvent"
        );
        rowNode.setDataValue("am_supply", newAmK + row.am_vat, "noEvent");
        break;
      }

      case "am_k": {
        rowNode.setDataValue("am", am_k / rt_exch, "noEvent");
        rowNode.setDataValue(
          "am_vat",
          Math.floor((am_k * vat_late) / 100),
          "noEvent"
        );
        rowNode.setDataValue(
          "am_supply",
          am_k + Math.floor((am_k * vat_late) / 100),
          "noEvent"
        );
        break;
      }

      case "am_vat": {
        rowNode.setDataValue(
          "am_supply",
          am_k + Math.floor((am_k * vat_late) / 100),
          "noEvent"
        );
        break;
      }
    }
  };
  const onAfterSetFooter = () => {
    const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    const footerData = gridRefs.current["grid2"].current.getFooterData();
    if (focusedNodeH) {
      focusedNodeH.setDataValue("am", footerData.am);
      focusedNodeH.setDataValue("am_k", footerData.am_k);
      focusedNodeH.setDataValue("am_vat", footerData.am_vat);
      focusedNodeH.setDataValue("am_supply", footerData.am_supply);
    }
  };

  //#region Filter
  const onFocusedRowChanged = async (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const isNew = selectedRow?._isNew === true;
      setIsNewRow(isNew);

      // 수주가 바뀔 때마다 하단 피벗을 즉시 갱신해야 해서, 서버 재조회 없이 캐시에서 재구성한다.
      const virtual: any[] = [];
      const no_so = selectedRow.no_so;
      // 선택된 수주(no_so)만 뽑아서 피벗 대상 데이터를 최소화한다.
      const filteredLongRows = pivotLongDataRef.current.filter(
        (row: any) => row.no_so === no_so
      );
      // 1) 사이즈 목록을 만든다.
      //    - 같은 사이즈를 중복으로 담지 않기 위해 Map을 사용
      //    - 표시명은 nm_var3 우선, 없으면 코드로 대체
      const sizeMap = new Map<string, string>();
      filteredLongRows.forEach((row: any) => {
        const sizeKey = String(row.cd_var3).trim();
        const sizeLabel = String(row.nm_var3 ?? sizeKey).trim() || sizeKey;
        sizeMap.set(sizeKey, sizeLabel);
      });
      // 쿼리에서 내려온 순서를 유지한다 (업무에서 정의한 사이즈 순서가 있을 수 있음).
      const sizeList = Array.from(sizeMap, ([key, label]) => ({
        key,
        label,
      }));
      // 2) 사이즈를 고정 슬롯(qt_wo1~qt_wo20)에 매핑한다.
      //    - 컬럼 구조를 동적으로 바꾸면 화면/디자이너/엑셀 흐름이 깨지므로 슬롯을 유지한다.
      //    - 사이즈가 20개를 넘으면 초과분은 표시하지 않는다.
      const sizeToSlot = new Map<string, string>();
      sizeList.slice(0, sizeSlotColumns.length).forEach((size, index) => {
        sizeToSlot.set(size.key, sizeSlotColumns[index]);
      });
      const slotLabelByColumn = new Map<string, string>();
      sizeList.slice(0, sizeSlotColumns.length).forEach((size, index) => {
        slotLabelByColumn.set(sizeSlotColumns[index], size.label);
      });
      // 3) 피벗 row 구성 및 합산
      //    - rowKey는 스타일+FIT+COLOR+LOCATION 조합으로 묶는다.
      //    - 같은 rowKey 내에서 사이즈별 수량(qt)을 슬롯에 누적한다.
      //    - 슬롯에 값이 없으면 0으로 유지해서 그리드 합계/엑셀 계산이 깨지지 않게 한다.
      const groupedRows = new Map<string, any>();
      filteredLongRows.forEach((row: any) => {
        const rowKey = [
          row.no_style ?? "",
          row.cd_var1 ?? "",
          row.cd_var2 ?? "",
          row.cd_dummy01 ?? "",
        ].join("|");
        let pivotRow = groupedRows.get(rowKey);
        if (!pivotRow) {
          // rowKey 기준으로 피벗 "행"을 만들고, 사이즈 슬롯을 0으로 초기화한다.
          pivotRow = {
            no_style: row.no_style,
            nm_style: row.nm_style,
            no_so: row.no_so,
            cd_var1: row.cd_var1,
            cd_var2: row.cd_var2,
            cd_dummy01: row.cd_dummy01,
          };
          sizeSlotColumns.forEach((slot) => {
            pivotRow[slot] = 0;
          });
          groupedRows.set(rowKey, pivotRow);
        }
        const slot = sizeToSlot.get(`${row.cd_var3 ?? ""}`.trim());
        if (slot) {
          // 같은 rowKey 내에서 cd_var3에 해당하는 슬롯에 수량(qt)을 누적한다.
          pivotRow[slot] = Number(pivotRow[slot] ?? 0) + Number(row.qt ?? 0);
        }
      });
      // 4) 피벗 rowData 갱신: 탭 전환 없이도 즉시 반영되도록 상태를 교체한다.
      setDataSources((prev: any) => ({
        ...prev,
        grid3: Array.from(groupedRows.values()),
      }));
      gridRefs.current["grid2"].current.applyFilters({ no_so: no_so });
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
      gridRefs.current["grid3"].current.applyFilters({ no_so: no_so });
      gridRefs.current["grid3"].current.selectAndFocusRow(0);
      gridRefs.current["grid4"].current.applyFilters({ no_so: no_so });
      gridRefs.current["grid4"].current.selectAndFocusRow(0);

      // 5) 컬럼 구조는 유지하고 헤더/가시성만 갱신
      //    - 사용된 슬롯은 사이즈명으로 헤더를 바꿔 사용자가 바로 읽게 한다.
      //    - 미사용 슬롯은 숨겨서 화면을 단순하게 유지한다.
      columns.grid3.map((row: any) => {
        if (row.cd_column && sizeSlotColumns.includes(row.cd_column)) {
          const slotLabel = slotLabelByColumn.get(row.cd_column);
          const data = {
            nm_header: "Size",
            cd_column: row.cd_column,
            nm_column: slotLabel ?? row.nm_column,
            fg_visible: slotLabel ? "Y" : "N",
          };
          virtual.push(data);
        }
      });
      gridRefs.current["grid3"].current.changeGroupColumnConfigs(virtual);
      setSelectedDocu(no_so);
    } else {
      return;
    }
  };

  //region OnTabChanged
  const onTabChanged = (index: string) => {
    setSelectedTab(index);

    if (focusedRowData) {
      const no_so = focusedRowData.no_so;
      const gridMap: { [key: string]: React.RefObject<any> } = {
        "1": gridRefs.current["grid2"],
        "2": gridRefs.current["grid3"],
      };

      const currentGrid = gridMap[index];
      if (currentGrid && currentGrid.current) {
        currentGrid.current.applyFilters({ no_so });
        gridRefs.current["grid2"].current.selectAndFocusRow(0);
        gridRefs.current["grid4"].current.applyFilters({ no_so });
        gridRefs.current["grid4"].current.selectAndFocusRow(0);
      }
    }
  };
  const onBeforeAddRowL = () => {
    try {
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      noLineTexRef.current += 1;

      const today = dateToString(new Date());
      return {
        ...addRowDefaultRef.current, // ←
        cd_firm: userInfo.cd_firm,
        no_so: focusedNodeH.data?.no_so,
        cd_biz: userInfo?.cd_biz,
        cd_dept: userInfo?.cd_dept,
        cd_emp: userInfo?.cd_emp,
        nm_emp: userInfo?.nm_emp,
        cd_gp: userInfo?.cd_gp,
        fg_money: "1",
        tp_um: "001",
        cd_exch: "000",
        rt_exch: 1,
        no_line_tex: noLineTexRef.current,
        no_line: 1,
        dt_dlv: focusedNodeH.data.dt_dlv,
        um: 0,
        use_dc_dummy01: "Y",
      };
    } catch (error: any) {
      return false;
    }
  };

  //#endregion

  const onRowDataReady = () => {
    const focusKey = focusKeyRef.current;
    if (!focusKey) return;

    const grid = gridRefs.current["grid1"].current;

    const rowCount = grid.getDisplayedRowCount();
    let targetIndex = -1;

    for (let i = 0; i < rowCount; i++) {
      const rowNode = grid.getRowNodeAtIndex(i);
      if (!rowNode?.data) continue;

      if (rowNode.data.no_so === focusKey.no_so) {
        targetIndex = i;
        break;
      }
    }

    if (targetIndex >= 0) {
      grid.selectAndFocusRow(targetIndex);
      grid.scrollToIndex?.(targetIndex);
    } else {
      grid.selectAndFocusRow(0);
    }

    focusKeyRef.current = null;
  };

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged,
          onCellValueChanged: onCellValueChangedH,
          onRowDataReady: onRowDataReady,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onCellValueChanged: onCellValueChangedL,
          onBtnAddClick: onGrid2BtnsClick,
          onBtnDeleteClick: onGrid2BtnsClick,
          onRowDoubleClick: onRowDoubleClick,
          onBeforeAddRow: onBeforeAddRowL,
          onAfterSetFooter: onAfterSetFooter,
        },
      },

      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
      },
      grid4: {
        columns: columns.grid4,
        dataSource: dataSources.grid4,
      },
      sheet1: {
        columns: columns.sheet1,
        dataSource: dataSources.sheet1,
      },
    }),
    [columns, dataSources]
  );

  //region UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1">
        <SnResizeBar direction={"height"} id="panel1" orgSize="49.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{
              rowSelection: "single",
              title: "수주정보",
              enableInitialSort: false,
            }}
            events={grids.grid1.events}
            header={
              <div>
                <SnButton
                  text={"출하마감"}
                  onClick={() => {
                    onGridBtnsClick("stSoC");
                  }}
                />
                <SnButton
                  text={"강제마감"}
                  onClick={() => {
                    onGridBtnsClick("stSoEnd");
                  }}
                />
                <SnButton
                  text={"마감취소"}
                  onClick={() => {
                    onGridBtnsClick("stSoCancel");
                  }}
                />
              </div>
            }
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel1" orgSize="49.5%">
          <SnTab
            titles={["내역정보", "Pivot"]}
            width={"100%"}
            onTabChanged={onTabChanged}
            header={[
              isNewRow ? (
                <SnTabHeader
                  onBtnAddClick={onGridBtnsClick1}
                  onBtnDeleteClick={onGridBtnsClick1}
                />
              ) : null,
              isNewRow ? (
                <SnTabHeader
                  onBtnAddClick={onGridBtnsClick2}
                  onBtnDeleteClick={onGridBtnsClick2}
                />
              ) : null,
            ]}
            body={[
              <div className="h-full">
                <SnGrid
                  ref={gridRefs.current["grid2"]} // Grid Name
                  columnConfig={grids.grid2.columns} // 컬럼 설정 전달
                  rowData={grids.grid2.dataSource} // Datasource
                  etcProps={{ rowSelection: "multiple" }}
                  events={grids.grid2.events}
                />
              </div>,
              <div className="h-full">
                <SnGrid
                  ref={gridRefs.current["grid3"]} // Grid Name
                  columnConfig={grids.grid3.columns} // 컬럼 설정 전달
                  rowData={grids.grid3.dataSource} // Datasource
                  etcProps={{ rowSelection: "multiple" }}
                />
              </div>,
              <div style={{ display: "none" }}>
                <SnGrid
                  ref={gridRefs.current["grid4"]} // Grid Name
                  columnConfig={grids.grid4.columns} // 컬럼 설정 전달
                  rowData={grids.grid4.dataSource} // Datasource
                  etcProps={{ rowSelection: "multiple" }}
                />
              </div>,
              <div style={{ display: "none" }}>
                <SnGrid
                  ref={sheetref1} // Grid Name
                  columnConfig={grids.sheet1.columns} // 컬럼 설정 전달
                  rowData={grids.sheet1.dataSource} // Datasource
                />
              </div>,
            ]}
          />
        </SnResizeBar>
        <SnFileUploadBox
          selectedDocu={selectedDocu}
          selectedLineDocu={selectedLineDocu}
        />
      </div>
    </div>
  );
});

export default SN_SAL_SAO_REG_001_TEX;
